import {TypeNatureMarcheChoix} from './TypeNatureMarcheChoix';
import { TypeObjCPV } from './TypeObjCPV';
export class TypeFNSSimpleDescMarche2 {

	public description: string;

	public criteresAttrib: string;

	public intitule: string;

	public codeCPV: TypeObjCPV;

	public natureMarche: TypeNatureMarcheChoix;

	constructor() {
		this.description = '';
		this.criteresAttrib = '';
		this.intitule = '';
		this.codeCPV = new TypeObjCPV();
		this.natureMarche = new TypeNatureMarcheChoix();

	}
}
